module.exports = __webpack_public_path__ + "static/25-116cf6dde40971009791e5f0a171368f.jpg";